import { FC } from 'react';

import { getLocalSvgIcon } from '@telialt/common-icon/src/utils';

import { DisneyIconModeDesktop, DisneyIconModeMobile, DualMode } from './AdaptiveDisneyIcon.styles';

export const AdaptiveDisneyIcon: FC<{ className?: string }> = ({ className }) => {
    const disneyLogoSmall = getLocalSvgIcon('disney-logo-small');

    return (
        <DualMode className={className}>
            <DisneyIconModeDesktop />
            <DisneyIconModeMobile svg={disneyLogoSmall} />
        </DualMode>
    );
};
